import React, { PropsWithChildren } from 'react';
import { CDN_URL } from '@logsnag/constants/src/cdn';
import Script from 'next/script';

interface ILogSnagProviderProps {
  project: string;
  token: string;
}

/**
 * Set up the LogSnag provider
 * @param props: ILogSnagProviderProps
 * @constructor
 */
export const LogSnagProvider: React.FC<
  PropsWithChildren<ILogSnagProviderProps>
> = ({ project, token, children }) => {
  return (
    <>
      <Script id="logsnag-script" async defer src={CDN_URL} />
      <Script
        id="logsnag-init"
        dangerouslySetInnerHTML={{
          __html: `
            window.lsq = window.lsq || [];
            window.ls = window.ls || ((...args) => window.lsq.push(args));
            window.ls('setConfig', '${token}', '${project}');
          `
        }}
      />
      {children}
    </>
  );
};
